import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TaskList } from '../../components/TaskList'
import '../TaskViews.scss'
import './TutorialProjectPage.scss'

interface TutorialTask {
  id: string
  titleKey: string
}

const TUTORIAL_TASKS: TutorialTask[] = [
  { id: 'task1', titleKey: 'tutorial.task1Title' },
  { id: 'task2', titleKey: 'tutorial.task2Title' },
  { id: 'task3', titleKey: 'tutorial.task3Title' },
  { id: 'task4', titleKey: 'tutorial.task4Title' },
  { id: 'task5', titleKey: 'tutorial.task5Title' },
]

export const TutorialProjectPage: React.FC = () => {
  const { t } = useTranslation()
  const [completed, setCompleted] = useState<Set<string>>(new Set())

  const handleToggleComplete = useCallback((ids: Set<string>) => {
    setCompleted(prev => {
      const next = new Set(prev)
      for (const id of ids) {
        if (next.has(id)) next.delete(id)
        else next.add(id)
      }
      return next
    })
  }, [])

  return (
    <div className="task-view tutorial-project">
      <div className="task-view__header">
        <div className="task-view__title-section">
          <h2 className="task-view__title">{t('tutorial.projectName')}</h2>
          <p className="tutorial-project__description">{t('tutorial.pageDescription')}</p>
        </div>
      </div>

      <div className="tutorial-project__section">
        <h3 className="tutorial-project__section-header">{t('tutorial.sectionBasics')}</h3>

        <TaskList
          tasks={TUTORIAL_TASKS.map(task => ({
            id: task.id,
            title: t(task.titleKey),
            completed: completed.has(task.id),
          }))}
          onToggleComplete={handleToggleComplete}
        />
      </div>
    </div>
  )
}
